import { DragDropModule } from '@angular/cdk/drag-drop';
import { LayoutModule } from '@angular/cdk/layout';
import { CdkTreeModule } from '@angular/cdk/tree';
import { DatePipe, HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MtxTooltipModule } from '@ng-matero/extensions';
import { StoreModule } from '@ngrx/store';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatFileUploadModule } from 'angular-material-fileupload';
import { HighchartsChartModule } from 'highcharts-angular';
import { NgxCaptureModule } from 'ngx-capture';
import { UserAccountConstants } from 'src/constants/useraccount.constants';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AccountComponent } from './components/account/account.component';
import { AcheminementComponent } from './components/acheminement/acheminement.component';
import { AdministrationComponent } from './components/administration/administration.component';
import { AgencyComponent } from './components/agency/agency.component';
import { CallForTenderListComponent } from './components/call-for-tender-list/call-for-tender-list.component';
import { CallForTenderComponent } from './components/call-for-tender/call-for-tender.component';

import { AtelierComponent } from './components/atelier/atelier.component';
import { CombustibleComponent } from './components/combustible/combustible.component';
import { BarIndicatorsDetailedBySolutionsComponent } from './components/ecopro-results-graphs/bar-indicators-detailed-bySolutions/bar-indicators-detailed-bySolutions.component';
import { BarIndicatorsDetailedByStationsComponent } from './components/ecopro-results-graphs/bar-indicators-detailed-byStations/bar-indicators-detailed-byStations.component';
import { BarIndicatorsDetailedByStructureTypesComponent } from './components/ecopro-results-graphs/bar-indicators-detailed-byStructureTypes/bar-indicators-detailed-byStructureTypes.component';
import { BarIndicatorsGlobalByStationsComponent } from './components/ecopro-results-graphs/bar-indicators-global-byStations/bar-indicators-global-byStations.component';
import { BarIndicatorsGlobalByStructureTypesComponent } from './components/ecopro-results-graphs/bar-indicators-global-byStructureTypes/bar-indicators-global-byStructureTypes.component';
import { RadarIndicatorsComponent } from './components/ecopro-results-graphs/radar-indicators/radar-indicators.component';
import { SunburstIndicatorsByStationsComponent } from './components/ecopro-results-graphs/sunburst-indicators-byStations/sunburst-indicators-byStations.component';
import { SunburstIndicatorsByStructureTypesComponent } from './components/ecopro-results-graphs/sunburst-indicators-byStructureTypes/sunburst-indicators-byStructureTypes.component';
import { EmailComponent } from './components/email/email.component';
import { EnergieComponent } from './components/energie/energie.component';
import { EnginComponent } from './components/engin/engin.component';
import { FormulaComponent } from './components/formula/formula.component';
import { HelpComponent } from './components/help/help.component';
import { IndustrieComponent } from './components/industrie/industrie.component';
import { IndustrieValidationComponent } from './components/industrie-validation/industrie-validation.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LoginComponent } from './components/login/login.component';
import { InscriptionComponent } from './components/inscription/inscription.component';
import { SsoComponent } from './components/sso/sso.component';
import { MemberComponent } from './components/member/member.component';

import { ListUserEntityComponent } from './components/nav-lists/list-user-entity/list-user-entity.component';
import { NavComponent } from './components/nav/nav.component';
import { NavbarComponent } from './components/navbar/navbar.component';

import { ProductComponent } from './components/product/product.component';
import { ProjectComponent } from './components/project/project.component';
import { ProjectStepProjectComponent } from './components/project/steps/project-step-project/project-step-project.component';
import { ProjectStepResultComponent } from './components/project/steps/project-step-result/project-step-result.component';
import { ProjectStepSolutionsComponent } from './components/project/steps/project-step-solutions/project-step-solutions.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ScenarioProjectComponent } from './components/scenario-project/scenario-project.component';
import { ActionBarComponent } from './components/shared/action-bar/action-bar.component';
import { BadgeStatutComponent } from './components/shared/badge-statut/badge-statut.component';
import { BreadcrumbsComponent } from './components/shared/breadcrumbs/breadcrumbs.component';
import { ConfirmCancelDialogComponent } from './components/shared/confirm-cancel-dialog/confirm-cancel-dialog.component';
import { DialogAddCompositionComponent } from './components/shared/dialog-add-composition/dialog-add-composition.component';
import { DialogChangeEnginComponent } from './components/shared/dialog-change-engin/dialog-change-engin.component';
import { DialogCheckScenarioDatasComponent } from './components/shared/dialog-check-scenario-datas/dialog-check-scenario-datas.component';
import { DialogComplexProductCompositionComponent } from './components/shared/dialog-complex-product-composition/dialog-complex-product-composition.component';
import { DialogCompositionComponent } from './components/shared/dialog-composition/dialog-composition.component';
import { DialogCopyOperationComponent } from './components/shared/dialog-copy-operation/dialog-copy-operation.component';
import { DialogCopyProjectEcoProComponent } from './components/shared/dialog-copy-project-ecopro/dialog-copy-project-ecopro.component';
import { DialogCreateDredgingFuelComponent } from './components/shared/dialog-create-dredging-fuel/dialog-create-dredging-fuel.component';
import { DialogDisplayCeuComponent } from './components/shared/dialog-display-ceu/dialog-display-ceu/dialog-display-ceu.component';
import { DialogDownloadCalculCeuEnginsComponent } from './components/shared/dialog-download-calcul-ceu-engins/dialog-download-calcul-ceu-engins.component';
import { DialogDredgingEquipmentComponent } from './components/shared/dialog-dredging-equipment/dialog-dredging-equipment.component';
import { DialogEditCombustibleFormulaComponent } from './components/shared/dialog-edit-combustible-formula/dialog-edit-combustible-formula.component';
import { DialogEditCompositionComponent } from './components/shared/dialog-edit-composition/dialog-edit-composition.component';
import { DialogEditEnginComponent } from './components/shared/dialog-edit-engin/dialog-edit-engin.component';
import { DialogEditOperationComponent } from './components/shared/dialog-edit-operation/dialog-edit-operation.component';
import { DialogEditProductMultimodalQuantityComponent } from './components/shared/dialog-edit-product-multimodal-quantity/dialog-edit-product-multimodal-quantity.component';
import { DialogEditProofComponent } from './components/shared/dialog-edit-proof/dialog-edit-proof.component';
import { DialogEditRatioComponent } from './components/shared/dialog-edit-ratio/dialog-edit-ratio.component';
import { DialogEmailStatusComponent } from './components/shared/dialog-email-status/dialog-email-status.component';
import { DialogEmailDetailComponent } from './components/shared/dialog-email-detail/dialog-email-detail.component';
import { DialogRegisterRequestComponent } from './components/shared/dialog-register-request/dialog-register-request.component';
import { DialogEnginComponent } from './components/shared/dialog-engin/dialog-engin.component';
import { DialogFamilyComponent } from './components/shared/dialog-family/dialog-family.component';
import { DialogFormulaCompositionComponent } from './components/shared/dialog-formula-composition/dialog-formula-composition.component';
import { DialogFusionUserEntityComponent } from './components/shared/dialog-fusion-user-entity/dialog-fusion-user-entity.component';
import { DialogImportProjectComponent } from './components/shared/dialog-import-project/dialog-import-project.component';
import { DialogImportSeveFileComponent } from './components/shared/dialog-import-seve-file/dialog-import-seve-file.component';
import { DialogInfoComponent } from './components/shared/dialog-info/dialog-info.component';
import { DialogInputComponent } from './components/shared/dialog-input/dialog-input.component';
import { DialogDuplicateCodeComponent } from './components/shared/dialog-duplicate-code/dialog-duplicate-code.component';
import { DialogJourneyComponent } from './components/shared/dialog-journey/dialog-journey.component';
import { DialogJustificativeComponent } from './components/shared/dialog-justificative/dialog-justificative.component';
import { DialogLeaveComponent } from './components/shared/dialog-leave/dialog-leave.component';
import { DialogOverviewComponent } from './components/shared/dialog-overview/dialog-overview.component';
import { DialogRejectCustomIndustryRequestComponent } from './components/shared/dialog-reject-custom-industry-request/dialog-reject-custom-industry-request.component';
import { DialogRenameCopyComponent } from './components/shared/dialog-rename-copy/dialog-rename-copy.component';
import { DialogRightUserComponent } from './components/shared/dialog-right-user/dialog-right-user.component';
import { DialogCreatePersonalAccessTokenComponent } from './components/shared/dialog-create-personal-access-token/dialog-create-personal-access-token.component';
import { PersonalAccessTokenComponent } from './components/personal-access-token/personal-access-token.component';
import { PartnerApiComponent } from './components/partner-api/partner-api.component';
import { DialogScenarioComponent } from './components/shared/dialog-scenario/dialog-scenario.component';
import { DialogSelectAgencyComponent } from './components/shared/dialog-select-agency/dialog-select-agency.component';
import { DialogSelectEuPublishComponent } from './components/shared/dialog-select-eu-publish/dialog-select-eu-publish.component';
import { DialogSelectEuShareComponent } from './components/shared/dialog-select-eu-share/dialog-select-eu-share.component';
import { DialogSelectSolutionComponent } from './components/shared/dialog-select-solution/dialog-select-solution.component';
import { DialogShareProjectComponent } from './components/shared/dialog-share-project/dialog-share-project.component';
import { DialogSolutionEcoProComponent } from './components/shared/dialog-solution-eco-pro/dialog-solution-eco-pro.component';
import { DialogSolutionScenarioComponent } from './components/shared/dialog-solution-scenario/dialog-solution-scenario.component';
import { DialogSolutionComponent } from './components/shared/dialog-solution/dialog-solution.component';
import { DialogStructureComponent } from './components/shared/dialog-structure/dialog-structure.component';
import { DialogSubstructureFormComponent } from './components/shared/dialog-substructure-form/dialog-substructure-form.component';
import { DialogTripComponent } from './components/shared/dialog-trip/dialog-trip.component';
import { DialogTunnelingEquipmentComponent } from './components/shared/dialog-tunneling-equipment/dialog-tunneling-equipment.component';
import { DialogUploadJustificativesComponent } from './components/shared/dialog-upload-justificatives/dialog-upload-justificatives.component';
import { EditableFieldComponent } from './components/shared/editable-field/editable-field.component';
import { IdentificationComponent } from './components/shared/identification/identification.component';
import { KeyboardShortcutsInterceptorComponent } from './components/shared/keyboard-shortcuts-interceptor/keyboard-shortcuts-interceptor.component';
import { RessourceListComponent } from './components/shared/ressource-list/ressource-list.component';
import { SpinnerOverlayComponent } from './components/shared/spinner-overlay/spinner-overlay.component';
import { TableComponent } from './components/shared/table/table.component';
import { SolutionOperationComponent } from './components/solution-operation/solution-operation.component';
import { StatisticComponent } from './components/statistic/statistic.component';
import { StatisticProfileComponent } from './components/statistic/statisticProfile.component';

import { SyntheseComponent } from './components/synthese/synthese.component';

import { DredgingEquipmentInfoComponent } from './components/dredging-equipment-info/dredging-equipment-info.component';
import { DredgingFuelComponent } from './components/dredging-fuel/dredging-fuel.component';
import { DialogGenerateFdesComponent } from './components/shared/dialog-generate-fdes/dialog-generate-fdes.component';
import { FdesThermalCardComponent } from './components/shared/fdes-thermal-card/fdes-thermal-card.component';
import { TranslationComponent } from './components/translation/translation.component';
import { TransportComponent } from './components/transport/transport.component';
import { TunnelingEquipmentInfoComponent } from './components/tunneling-equipment-info/tunneling-equipment-info.component';
import { UserEntityComponent } from './components/user-entity/user-entity.component';
import { UserComponent } from './components/user/user.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { WorkInspectionProjectComponent } from './components/work-inspection-project/work-inspection-project.component';
import { WorkInspectionSolutionsComponent } from './components/work-inspection-solutions/work-inspection-solutions.component';
import { WorkInspectionComponent } from './components/work-inspection/work-inspection.component';
import { ConfirmToggleDirective } from './core/_directives/confirm-toggle.directive';
import { EnterToSaveDirective } from './core/_directives/enter-to-save.directive';
import { HighchartsAutoReflowDirective } from './core/_directives/highcharts-auto-reflow.directive';
import { CanDeactivateGuard } from './core/_helpers/save.guard';
import { RegionInterceptor } from './core/_interceptors/region.interceptor';
import { ToFixedPipe } from './core/_pipes/to-fixed.pipe';
import { ToNumberPipe } from './core/_pipes/to-number.pipe';
import { LocalizedLabelPipe } from './core/_pipes/localized-label.pipe';
import { LocalizedDatePipe } from './core/_pipes/localized-date.pipe';
import { LocalizedNumberPipe } from './core/_pipes/localized-number.pipe';
import { ResourceAuthorPipe } from './core/_pipes/resource-author.pipe';
import { ErrorIntercept } from './core/_utils/error-intercept';
import { ResourceReducer } from './store/reducers/resource.reducer';

registerLocaleData(localeFr);

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatButtonModule,
    LayoutModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    MatExpansionModule,
    HttpClientModule,
    MatChipsModule,
    MatCardModule,
    MatGridListModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    ScrollingModule,
    MatFileUploadModule,
    StoreModule.forRoot({ resources: ResourceReducer }),
    MatSnackBarModule,
    MatDialogModule,
    MatTabsModule,
    CdkTreeModule,
    DragDropModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatMenuModule,
    MatDividerModule,
    MatTreeModule,
    MatTableModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    AngularEditorModule,
    BrowserAnimationsModule,
    MatSlideToggleModule,
    MtxTooltipModule,
    HighchartsChartModule,
    NgxCaptureModule,
    DragDropModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    AppComponent,
    NavComponent,
    NavbarComponent,
    AcheminementComponent,
    LayoutComponent,
    LoginComponent,
    InscriptionComponent,
    SsoComponent,
    CombustibleComponent,
    TransportComponent,
    IdentificationComponent,
    DialogOverviewComponent,
    SpinnerOverlayComponent,
    DialogTripComponent,
    DialogJourneyComponent,
    ProductComponent,
    EnginComponent,
    AtelierComponent,
    FormulaComponent,
    DialogEditCompositionComponent,
    DialogAddCompositionComponent,
    DialogEditEnginComponent,
    DialogEditCombustibleFormulaComponent,
    WelcomeComponent,
    DialogLeaveComponent,
    DialogInfoComponent,
    DialogInputComponent,
    DialogSolutionComponent,
    DialogRenameCopyComponent,
    DialogDuplicateCodeComponent,
    DialogEditOperationComponent,
    IndustrieComponent,
    IndustrieValidationComponent,
    DialogRejectCustomIndustryRequestComponent,
    EnergieComponent,
    ScenarioProjectComponent,
    AgencyComponent,
    MemberComponent,
    UserComponent,
    StatisticComponent,
    StatisticProfileComponent,
    AdministrationComponent,
    EmailComponent,
    AccountComponent,
    ResetPasswordComponent,
    CallForTenderComponent,
    CallForTenderListComponent,
    DialogScenarioComponent,
    DialogSolutionScenarioComponent,
    DialogRightUserComponent,
    DialogCreatePersonalAccessTokenComponent,
    PersonalAccessTokenComponent,
    PartnerApiComponent,
    UserEntityComponent,
    ListUserEntityComponent,
    DialogFusionUserEntityComponent,
    DialogFamilyComponent,
    SyntheseComponent,
    DialogSelectEuShareComponent,
    DialogSelectEuPublishComponent,
    ToNumberPipe,
    LocalizedLabelPipe,
    LocalizedDatePipe,
    LocalizedNumberPipe,
    ToFixedPipe,
    ResourceAuthorPipe,
    DialogDisplayCeuComponent,
    DialogCheckScenarioDatasComponent,
    DialogCopyOperationComponent,
    DialogEmailStatusComponent,
    DialogEmailDetailComponent,
    DialogRegisterRequestComponent,
    DialogSelectAgencyComponent,
    DialogEditRatioComponent,
    DialogSubstructureFormComponent,
    DialogStructureComponent,
    DialogCompositionComponent,
    DialogSolutionEcoProComponent,
    DialogEnginComponent,
    DialogCopyProjectEcoProComponent,
    BarIndicatorsDetailedByStationsComponent,
    BarIndicatorsDetailedBySolutionsComponent,
    BarIndicatorsDetailedByStructureTypesComponent,
    BarIndicatorsGlobalByStationsComponent,
    BarIndicatorsGlobalByStructureTypesComponent,
    RadarIndicatorsComponent,
    SunburstIndicatorsByStationsComponent,
    SunburstIndicatorsByStructureTypesComponent,
    DialogComplexProductCompositionComponent,
    DialogFormulaCompositionComponent,
    DialogChangeEnginComponent,
    DialogEditProductMultimodalQuantityComponent,
    DialogShareProjectComponent,
    DialogDownloadCalculCeuEnginsComponent,
    DialogDredgingEquipmentComponent,
    DialogCreateDredgingFuelComponent,
    DialogTunnelingEquipmentComponent,
    BadgeStatutComponent,
    EditableFieldComponent,
    KeyboardShortcutsInterceptorComponent,
    ActionBarComponent,
    BreadcrumbsComponent,
    DialogImportProjectComponent,
    DialogImportSeveFileComponent,
    ConfirmCancelDialogComponent,
    RessourceListComponent,
    DialogSelectSolutionComponent,
    WorkInspectionComponent,
    WorkInspectionSolutionsComponent,
    DialogJustificativeComponent,
    DialogUploadJustificativesComponent,
    DialogEditProofComponent,
    SolutionOperationComponent,
    WorkInspectionProjectComponent,
    TableComponent,
    ProjectComponent,
    ProjectStepProjectComponent,
    ProjectStepSolutionsComponent,
    ProjectStepResultComponent,
    TranslationComponent,
    HelpComponent,
    DredgingEquipmentInfoComponent,
    TunnelingEquipmentInfoComponent,
    DredgingFuelComponent,
    DialogGenerateFdesComponent,
    FdesThermalCardComponent,
    HighchartsAutoReflowDirective,
    EnterToSaveDirective,
    ConfirmToggleDirective
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorIntercept,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RegionInterceptor,
      multi: true
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'fr-FR'
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    CanDeactivateGuard,
    ToNumberPipe,
    DatePipe,
    UserAccountConstants
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
